<template>
  <div class="vehicle-root">
    <div>
      <Form @submit="onSubmit">
        <Card title="联系方式">
          <Field
            v-model="userName"
            name="name"
            label="姓名"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <Field
            v-model="phoneNumber"
            name="mobile"
            label="手机号"
            type="tel"
            placeholder="请输入手机号"
            :rules="[{ required: true, message: '请填写手机号' }]"
          />
        </Card>
        <Card title="车辆信息">
          <Field
            v-model="carNumber"
            name="car_number"
            label="车牌号"
            placeholder="请输入车牌号"
          />
          <Field
            v-model="carBrand"
            name="car_brand"
            label="汽车品牌"
            type="tel"
            placeholder="请输入汽车品牌"
          />
          <Field
            v-model="carModel"
            name="car_model"
            label="汽车型号"
            type="tel"
            placeholder="请输入汽车型号"
          />
        </Card>
        <Card title="保险服务">
          <Field
            readonly
            clickable
            name="insuranceCompany"
            :value="insurance"
            label="保险公司"
            placeholder="点击选择保险公司"
            @click="showPicker = true"
          />
          <Field name="insurance_jqx" label="交强险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insuranceJqx" size="20" />
              </div>
            </template>
          </Field>
          <Collapse v-model="activeName" accordion>
            <CollapseItem title="第三责任险" name="1">
              <Field name="insurance_dsxr">
                <template #input>
                  <div style="width:100%">
                    <RadioGroup v-model="radio1">
                      <CellGroup :border="false">
                        <Cell title="20万" clickable @click=" radio = '20万'">
                          <Radio slot="right-icon" name="20万" />
                        </Cell>
                        <Cell title="30万" clickable @click=" radio = '30万'">
                          <Radio slot="right-icon" name="30万" />
                        </Cell>
                        <Cell title="50万" clickable @click=" radio = '50万'">
                          <Radio slot="right-icon" name="50万" />
                        </Cell>
                        <Cell title="100万" clickable @click=" radio = '100万'">
                          <Radio slot="right-icon" name="100万" />
                        </Cell>
                      </CellGroup>
                    </RadioGroup>
                  </div>
                </template>
              </Field>
            </CollapseItem>
            <CollapseItem title="车上人员责任险-司机" name="2">
              <Field name="insurance_sj">
                <template #input>
                  <div style="width:100%">
                    <RadioGroup v-model="radio2">
                      <CellGroup :border="false">
                        <Cell title="5万" clickable @click=" radio = '5万'">
                          <Radio slot="right-icon" name="5万" />
                        </Cell>
                        <Cell title="20万" clickable @click=" radio = '20万'">
                          <Radio slot="right-icon" name="20万" />
                        </Cell>
                        <Cell title="30万" clickable @click=" radio = '30万'">
                          <Radio slot="right-icon" name="30万" />
                        </Cell>
                        <Cell title="50万" clickable @click=" radio = '50万'">
                          <Radio slot="right-icon" name="50万" />
                        </Cell>
                      </CellGroup>
                    </RadioGroup>
                  </div>
                </template>
              </Field>
            </CollapseItem>
            <CollapseItem title="车上人员责任险-乘客" name="3">
              <Field name="insurance_ck">
                <template #input>
                  <div style="width:100%">
                    <RadioGroup v-model="radio3">
                      <CellGroup :border="false">
                        <Cell title="5万" clickable @click=" radio = '5万'">
                          <Radio slot="right-icon" name="5万" />
                        </Cell>
                        <Cell title="20万" clickable @click=" radio = '20万'">
                          <Radio slot="right-icon" name="20万" />
                        </Cell>
                        <Cell title="30万" clickable @click=" radio = '30万'">
                          <Radio slot="right-icon" name="30万" />
                        </Cell>
                        <Cell title="50万" clickable @click=" radio = '50万'">
                          <Radio slot="right-icon" name="50万" />
                        </Cell>
                      </CellGroup>
                    </RadioGroup>
                  </div>
                </template>
              </Field>
            </CollapseItem>
            <CollapseItem title="车上货物责任险" name="4">
              <Field name="insurance_hw">
                <template #input>
                  <div style="width:100%">
                    <RadioGroup v-model="radio4">
                      <CellGroup :border="false">
                        <Cell title="5万" clickable @click=" radio = '5万'">
                          <Radio slot="right-icon" name="5万" />
                        </Cell>
                        <Cell title="20万" clickable @click=" radio = '20万'">
                          <Radio slot="right-icon" name="20万" />
                        </Cell>
                        <Cell title="30万" clickable @click=" radio = '30万'">
                          <Radio slot="right-icon" name="30万" />
                        </Cell>
                        <Cell title="50万" clickable @click=" radio = '50万'">
                          <Radio slot="right-icon" name="50万" />
                        </Cell>
                      </CellGroup>
                    </RadioGroup>
                  </div>
                </template>
              </Field>
            </CollapseItem>
          </Collapse>
          <Field name="insurance_pl" label="玻璃单独破碎险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insurancePl" size="20" />
              </div>
            </template>
          </Field>
          <Field name="insurance_cshx" label="车身划痕损失险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insuranceCshx" size="20" />
              </div>
            </template>
          </Field>
          <Field name="insurance_csx" label="机动车辆损失险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insuranceCsx" size="20" />
              </div>
            </template>
          </Field>
          <Field name="insurance_fdjss" label="发动机涉水损失险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insuranceFdjss" size="20" />
              </div>
            </template>
          </Field>
          <Field name="insurance_zrss" label="自燃损失险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insuranceZrss" size="20" />
              </div>
            </template>
          </Field>
          <Field name="insurance_dqx" label="盗抢险" label-width='120px'>
            <template #input>
              <div class="switch-wrap">
                <van-switch v-model="insuranceDqx" size="20" />
              </div>
            </template>
          </Field>
        </Card>
        <div style="margin: 16px;">
          <Button round block type="info" native-type="submit">
            提交
          </Button>
        </div>
      </Form>
      <Popup
        v-model="showPicker"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <Picker
          show-toolbar
          title="请选择"
          :columns="columns"
          @cancel="onCancel"
          @confirm="onConfirm"
        />
      </Popup>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card'
import { Switch } from 'vant';
import { api,http } from 'utils/'
export default {
  data() {
    return{
      showPicker:false,
      // 交强险
      insuranceJqx:true,
      // 玻璃单独破碎险
      insurancePl:false,  
      // 车身划痕损失险
      insuranceCshx:false,
      // 机动车辆损失险
      insuranceCsx:false,
      // 发动机涉水损失险
      insuranceFdjss:false,
      // 自燃损失险
      insuranceZrss:false,
      // 盗抢险
      insuranceDqx:false,
      // 用户信息
      userName:"",
      phoneNumber:"",
      // 车辆信息
      carNumber:"",
      carBrand:"",
      carModel:"",
      activeName:'1',
      insurance:'',
      radio1:"",
      radio2:"",
      radio3:"",
      radio4:"",
      columns:['中国人民财产保险', '中华联合财产保险', '紫金保险', '平安保险']
    }
  },
  components:{
    Card,
    [Switch.name]:Switch
  },
  created() {
    document.title = '车辆续保'
  },
  methods:{
    async postHandle(data) {
      const res = await http({
        url:api.insurceApi,
        method:'POST',
        data:{
          ...data,
          service_type:1
        }
      })
      if(res) {
        this.$router.push('/success')
      }
      console.log(res)
    },
    onSubmit(values) {
      this.postHandle(values)
      console.log('submit', values);
    },
    onConfirm(value) {
      this.insurance = value
      this.showPicker = false;
    },
    onCancel() {
      this.showPicker = false
    }
  }
}
</script>

<style lang="less">
.vehicle-root{
  height: 100%;
  overflow: auto;
  padding: 20px 12px;
  .van-cell__title {
    text-align: left;
  }
  .van-collapse-item__content{
    padding: 0;
  }
  .label-wrap{
    width: 100px;
  }
  .switch-wrap{
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }
}
</style>